import { Button, Modal, Typography } from 'antd'

import { useTranslation } from 'react-i18next'
import { API } from '../../lib/api'
import { useLoading } from '../../lib/hooks/useLoading'
import { ModalProps } from './types'

export function ResetDemoPatients({ isVisible, onCancel }: ModalProps): React.ReactNode {
  const { t } = useTranslation()
  const [isLoading, withLoading] = useLoading()

  async function handleConfirm(): Promise<void> {
    const success = await withLoading(API.devResetDemoData())
    if (success) window.location.reload()
  }

  return (
    <Modal
      open={isVisible}
      onCancel={onCancel}
      title={t('menus.main.resetDemoPatients')}
      centered
      destroyOnHidden
      footer={
        <Button disabled={isLoading} loading={isLoading} type="primary" onClick={handleConfirm}>
          {t('menus.main.resetDemoModal.submit')}
        </Button>
      }
    >
      <Typography.Text>{t('menus.main.resetDemoModal.text')}</Typography.Text>
    </Modal>
  )
}
